import { IMAGE_SIZE, IMAGE_SIZE_PERCENTAGE } from '@services/images/constants';

function getWidthPercentageBySize(size = IMAGE_SIZE.MEDIUM) {
  switch (size) {
    case IMAGE_SIZE.BIG:
      return IMAGE_SIZE_PERCENTAGE.BIG;
    case IMAGE_SIZE.MEDIUM:
      return IMAGE_SIZE_PERCENTAGE.MEDIUM;
    case IMAGE_SIZE.SMALL:
      return IMAGE_SIZE_PERCENTAGE.SMALL;
    case IMAGE_SIZE.X_SMALL:
      return IMAGE_SIZE_PERCENTAGE.X_SMALL;
    default:
      return IMAGE_SIZE_PERCENTAGE.FULL;
  }
}

export default getWidthPercentageBySize;
